'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildResolvedAttachmentsMapFromResponse = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reduce = require('transmute/reduce');

var _reduce2 = _interopRequireDefault(_reduce);

var _immutable = require('immutable');

var _ResolvedAttachmentRecord = require('conversations-schema/resolved-attachment/records/ResolvedAttachmentRecord');

var _ResolvedAttachmentRecord2 = _interopRequireDefault(_ResolvedAttachmentRecord);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buildResolvedAttachmentsMapFromResponse = exports.buildResolvedAttachmentsMapFromResponse = function buildResolvedAttachmentsMapFromResponse(response) {
  return (0, _reduce2.default)((0, _immutable.Map)(), function (resolvedAttachments) {
    var resolvedAttachment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var fileIdKey = arguments[2];

    var fileId = parseInt(fileIdKey, 10);
    var attachmentRecord = new _ResolvedAttachmentRecord2.default(_extends({}, resolvedAttachment, {
      fileId: fileId
    }));

    return resolvedAttachments.set(fileId, attachmentRecord);
  }, response);
};


//////////////////
// WEBPACK FOOTER
// ./js/resolved-attachments/operators/buildResolvedAttachmentsMapFromResponse.js
// module id = 189
// module chunks = 2 3